// import { Form, Input, Button, ConfigProvider, Card, Switch } from "antd";
// import { UserOutlined, LockOutlined } from "@ant-design/icons";
// import { useState } from "react";
// import loginImage from "../../Assets/Images/LoginLogo.png";
// import minnotra_logo from "../../Assets/Images/logo2.png";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { isLoggedIn } from "../../Utils/UserSlice";
// import { handledarkMode } from "../Elements/DarkModeAction";

// const clientDatabase = {
//   adminsss:
//   {
//     password: "123",
//     modules: ["temperature", "water", "air", "electrical", "configuration", "steam"]
//   },
//   // client2:
//   // {
//   //   password: "temp",
//   //   modules: ["temperature"]
//   // },
//   // client3:
//   // { 
//   //   password: "client789",
//   //   modules: ["steam"]
//   // },
//   admin:
//   {
//     password: "123",
//     modules: ["temperature","configuration","electrical"]
//   },
// };
 
// const LoginForm = () => {
//   const [userData, setUserData] = useState({});
//   const [error, setError] = useState(null);

//   const loggedIn = useSelector((state)=>state.user.login)
//   console.log(loggedIn)
 

//   const switchDarkMode = () => {
//     isdarkMode ? dispatch(handledarkMode(false)) : dispatch(handledarkMode(true));
//   };

//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [form] = Form.useForm();

//   const handleInputChange = (changedValues, allValues) => {
//     setUserData(allValues);
//   };

//   const handleReset = () => {
//     form.resetFields();
//   };

//   const onSubmit = async () => {
//     try {
//       const { UserName, Password } = userData;
//       const client = clientDatabase[UserName]; 
//       console.log(client)
//       if (client && client.password === Password) {
//         dispatch(isLoggedIn(true));
//         navigate("/landing-page", { state: { modules: client.modules } });
//         handleReset();
//       } else {
//         setError("Invalid username or password");
//       }
//     } catch (err) {
//       console.error("Error in login:", err);
//     }
//   };

//   const mode = useSelector((state) => state.darkMode);

//   const { isdarkMode } = mode;
//   // console.log(isdarkMode)

//   return (
//     <div className=" h-screen w-full login-bg"  >
//     <div className={`flex  justify-evenly items-center md:h-screen md:flex-row dark ${isdarkMode ? 'darkmode' : 'whitemode'}` }
//    >
//       <div className={`sm:w-1/4  md:w-[400px] hidden md:block mr-10 `}>
//         <img
//           src={loginImage}
//           alt="Background"
//           className="h-full w-full object-cover"
//         />
//       </div>
//       <Card className={` flex justify-center items-center   ${isdarkMode ? '' : 'whitemodes'}`}>
//       <div className="form-container flex flex-col justify-center items-center min-h-full">
//             {/* <div className="absolute top-4 right-8 md:right-20 lg:right-20 darktheme-switch">

//               <Switch size="small" checked={isdarkMode} onChange={switchDarkMode} checkedChildren="Dark" unCheckedChildren="Light" />
//             </div> */}
//           {/* <div className="flex justify-center items-center h-full">
//             <img
//               className="w-40  mb-20 "
//               src={minnotra_logo}
//               alt="minnotra_logo"
//             />
//           </div> */}
//           <div className="mb-5">
//             <div className="text-lime-500 font-semibold text-center ">
//               <p className="text-xl">Welcome Experts</p>
//               <p className="mb-4 mt-0 text-black ">LOGIN</p>
//             </div>
//             {/* <p className={`text-zinc-500 text-md tracking-wide font-semibold text-center ${isdarkMode ? 'darkfont' : 'whitemode'} `}>
//               Welcome to the Expert Trax
//             </p> */}
//           </div>
//           <ConfigProvider
//             // theme={{
//             //   token: {
//             //     colorBgContainer: isdarkMode ? "#292c35" : "#f6ffed",
//             //     colorTextBase: isdarkMode ? "#fff" : "#000",
//             //   },
//             // }}
//             theme={{
//               token: {
//                 colorPrimary: "#52c41a", // Green (Ant Design Default Green)
//                 colorBgContainer: isdarkMode ? "#292c35" : "#f6ffed",
//                 colorTextBase: isdarkMode ? "#fff" : "#000",
//               },
//             }}
//           >
//             <Form
//               name="normal_login"
//               className="login-form"
//               initialValues={{
//                 remember: true,
//               }}
//               onFinish={onSubmit}
//               form={form}
//               onValuesChange={handleInputChange}
//             >
//               <Form.Item
//                 name="UserName"
//                 className={`login-input ${isdarkMode ? "login-input" : "#f6ffed"}`}
//                 rules={[
//                   {
//                     required: true,
//                     message: "Please input your Username!",
//                   },
//                 ]}
//               >
//                 <Input
//                   placeholder="Username"
//                   className="p-3 rounded-full login-input"
//                   prefix={<UserOutlined className="site-form-item-icon pl-2" />}

//                 />
//               </Form.Item>

//               <Form.Item
//                 name="Password"
//                 className="login-input"
//                 rules={[
//                   {
//                     required: true,
//                     message: "Please input your Password!",
//                   },
//                 ]}
//               >
//                 <Input
//                   prefix={<LockOutlined className="site-form-item-icon pl-2" />}
//                   type="password"
//                   placeholder="Password"
//                   className="p-3 w-[300px] rounded-full"
//                 />
//               </Form.Item>
//               {error && (
//                 <div className="text-center text-red-400 font-semibold text-sm">
//                   {error}
//                 </div>
//               )}
//               <Form.Item>
//               <Button
//         // type="primary"
//         htmlType="submit"
//         className="w-full border-1 rounded-full h-11 text-xl tracking-wide text-white bg-green-500 hover:bg-red-500 hover:text-green-500"
//       >
//         LOGIN
//       </Button>
//               </Form.Item>
//             </Form>
//           </ConfigProvider>
//         </div>
//       </Card>
//     </div>
//     </div>
//   );
// };

// export default LoginForm;







import { Form, Input, Button, ConfigProvider } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useState } from "react";
import loginImage from "../../Assets/Images/login2.png";
import minnotra_logo from "../../Assets/Images/logo2.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn } from "../../Utils/UserSlice";
import { handledarkMode } from "../Elements/DarkModeAction";

const clientDatabase = {
  adminsss:
  {
    password: "123",
    modules: ["temperature", "water", "air", "electrical", "configuration", "steam"]
  },
  // client2:
  // {
  //   password: "temp",
  //   modules: ["temperature"]
  // },
  // client3:
  // { 
  //   password: "client789",
  //   modules: ["steam"]
  // },
  admin:
  {
    password: "123",
    modules: ["temperature","configuration","electrical"]
  },
};
 
const LoginForm = () => {
  const [userData, setUserData] = useState({});
  const [error, setError] = useState(null);

  const loggedIn = useSelector((state)=>state.user)
  console.log(loggedIn)
 

  const switchDarkMode = () => {
    isdarkMode ? dispatch(handledarkMode(false)) : dispatch(handledarkMode(true));
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const handleInputChange = (changedValues, allValues) => {
    setUserData(allValues);
  };

  const handleReset = () => {
    form.resetFields();
  };

  const onSubmit = async () => {
    try {
      const { UserName, Password } = userData;
      const client = clientDatabase[UserName]; 
      console.log(client)
      if (client && client.password === Password) {
        dispatch(isLoggedIn({ name: UserName }));
        navigate("/landing-page", { state: { modules: client.modules } });
        handleReset();
      } else {
        setError("Invalid username or password");
      }
    } catch (err) {
      console.error("Error in login:", err);
    }
  };

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  // console.log(isdarkMode)

  return (
    <div className={`flex flex-col md:h-screen md:flex-row dark ${isdarkMode ? 'darkmode' : 'whitemode'}`}>
      <div className={`sm:w-1/4  md:w-3/4 hidden md:block `}>
        <img
          src={loginImage}
          alt="Background"
          className="h-full w-full object-cover"
        />
      </div>
      <div className={`md:w-2/4 lg:w-2/4 flex justify-center items-center min-h-screen dark ${isdarkMode ? 'darkmode' : 'whitemode'}`}>
      <div className="form-container flex flex-col justify-center items-center min-h-full">

        <label className="switch absolute top-4 right-8 md:right-20 lg:right-20 darktheme-switch">
              <input type="checkbox" checked={isdarkMode} onChange={switchDarkMode} />
              <span className="slider "></span>
            </label>
          <div className="flex justify-center items-center h-full">
            <img
              className="w-40  mb-20 "
              src={minnotra_logo}
              alt="minnotra_logo"
            />
          </div>
          <div className="mb-10">
            <div className="text-lime-500 font-semibold text-center text-4xl">
              <p>USER</p>
              <p className="mb-4">LOGIN</p>
            </div>
            <p className={`text-zinc-500 text-md tracking-wide font-semibold text-center ${isdarkMode ? 'darkfont' : 'whitemode'} `}>
              Welcome to the Expert Trax
            </p>
          </div>
          <ConfigProvider
            theme={{
              token: {
                colorBgContainer: isdarkMode ? "#292c35" : "#f6ffed",
                colorTextBase: isdarkMode ? "#fff" : "#000",
              },
            }}
          >
            <Form
              name="normal_login"
              className="login-form"
              initialValues={{
                remember: true,
              }}
              onFinish={onSubmit}
              form={form}
              onValuesChange={handleInputChange}
            >
              <Form.Item
                name="UserName"
                className={`login-input ${isdarkMode ? "login-input" : "#f6ffed"}`}
                rules={[
                  {
                    required: true,
                    message: "Please input your Username!",
                  },
                ]}
              >
                <Input
                  placeholder="Username"
                  className="p-3 rounded-full login-input"
                  prefix={<UserOutlined className="site-form-item-icon pl-2" />}

                />
              </Form.Item>

              <Form.Item
                name="Password"
                className="login-input"
                rules={[
                  {
                    required: true,
                    message: "Please input your Password!",
                  },
                ]}
              >
                <Input
                  prefix={<LockOutlined className="site-form-item-icon pl-2" />}
                  type="password"
                  placeholder="Password"
                  className="p-3 w-[300px] rounded-full"
                />
              </Form.Item>
              {error && (
                <div className="text-center text-red-400 font-semibold text-sm">
                  {error}
                </div>
              )}
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className={`login-form-button w-full border-0 rounded-full h-11 text-xl tracking-wide ${isdarkMode ? 'loginbtn' : 'whitemode'}`}
                >
                  LOGIN
                </Button>
              </Form.Item>
            </Form>
          </ConfigProvider>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
